import { type ReactNode } from 'react'
import { useCan } from './useCan'
import type { Permission } from './permissions'

interface CanProps {
  permission: Permission
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Muestra `children` si el usuario tiene el permiso. Reemplazo escalable del
 * `<RoleGuard>` para UI nueva — basado en permisos en vez de nombres de rol.
 */
export function Can({ permission, children, fallback = null }: CanProps) {
  const allowed = useCan(permission)
  return <>{allowed ? children : fallback}</>
}
